import { Form, Templates } from "@rjsf/material-ui";
import { RJSFSchema, SubmitButtonProps, getSubmitButtonOptions } from "@rjsf/utils";
import validator from "@rjsf/validator-ajv8";
import styled from "styled-components";
import { Button, CircularProgress } from "@material-ui/core";
import React, { createContext, useContext } from "react";
import ObjectFieldTemplate from "./ObjectFiledTemplate";
import CustomArrayFieldTemplate from "./CustomArrayFieldTemplate";
import ImageUrlWidget from "./ImageUrlWidget";
import VideoField from "./VideoField";
import CaptionUrlWidget from "./CaptionUrlWidget";

const SubmittingContext = createContext<boolean>(false);

// Uggly hack to fix width of array items. A custom array field might be a better solution.
// also a fix to show hidden delete button in arrays
const StyledForm = styled(Form)`
  .field-array {
    & .MuiGrid-root.MuiGrid-container.MuiGrid-align-items-xs-center {
      & > .MuiGrid-item:nth-child(2) {
        flex-grow: 0;
      }
    }
  }

  button.MuiIconButton-colorSecondary {
    color: red;
  }
`;

const AdditionalActionsContext = createContext<React.ReactNode>(null);

function CustomSubmitButton<T = any, S extends RJSFSchema = RJSFSchema, F = any>(
  props: SubmitButtonProps<T, S, F>
) {
  const { uiSchema } = props;
  const isSubmitting = useContext(SubmittingContext);
  const additionalActions = useContext(AdditionalActionsContext);
  const { submitText, norender, props: submitButtonProps = {} } = getSubmitButtonOptions(uiSchema);

  if (norender) {
    return null;
  }

  return (
    <div style={{ display: "flex", justifyContent: additionalActions ? "space-between" : "flex-end", alignItems: "center" }}>
      {additionalActions && (
        <div style={{ display: "flex" }}>
          {React.Children.map(additionalActions as React.ReactElement, (child, index) => (
            <div key={index} style={{ marginRight: index < React.Children.count(additionalActions as React.ReactElement) - 1 ? "16px" : 0 }}>
              {child}
            </div>
          ))}
        </div>
      )}
      <Button type="submit" variant="contained" color="primary" {...submitButtonProps} disabled={isSubmitting || submitButtonProps.disabled}>
        {isSubmitting ? <CircularProgress size={24} /> : submitText}
      </Button>
    </div>
  );
}

const buttonTemplates = {
  ...Templates.ButtonTemplates,
  SubmitButton: CustomSubmitButton,
};

export const GenericForm = ({
  schema,
  uiSchema,
  onSubmit,
  formData = {},
  onChange,
  isSubmitting,
  additionalActions,
}: {
  schema: RJSFSchema;
  uiSchema: RJSFSchema;
  onSubmit: (data: any) => void;
  formData?: any;
  onChange?: (data: any) => void;
  isSubmitting?: boolean;
  additionalActions?: React.ReactNode;
}) => {
  return (
    <SubmittingContext.Provider value={isSubmitting || false}>
      <AdditionalActionsContext.Provider value={additionalActions}>
        <StyledForm
          liveValidate
          schema={schema}
          uiSchema={uiSchema}
          formData={formData}
          widgets={{
            ImageUrlWidget: ImageUrlWidget,
            CaptionUrlWidget: CaptionUrlWidget,
          }}
          templates={{
            ...Templates,
            ObjectFieldTemplate: ObjectFieldTemplate,
            ArrayFieldTemplate: CustomArrayFieldTemplate,
            ButtonTemplates: buttonTemplates,
          }}
          fields={{
            VideoField: VideoField,
          }}
          onSubmit={e => {
            if (e.formData && onSubmit) {
              onSubmit(e.formData);
            }
          }}
          validator={validator}
          showErrorList={"bottom"}
          onChange={onChange}
        />
      </AdditionalActionsContext.Provider>
    </SubmittingContext.Provider>
  );
};
